import { render, staticRenderFns } from "./mailSettingList.vue?vue&type=template&id=7ef1c863&scoped=true&"
import script from "./mailSettingList.vue?vue&type=script&lang=js&"
export * from "./mailSettingList.vue?vue&type=script&lang=js&"
import style0 from "./mailSettingList.vue?vue&type=style&index=0&id=7ef1c863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef1c863",
  null
  
)

export default component.exports